
<template>
  <router-btn :text="$t('servicesystem.common_objects.fallbackterms.old_site')"
              :icon="'mdi-web-sync'"
              :color="'secondary'"
              :disabled="false"
              :outlined="false"
              :textbtn="textbtn"
              :large="large"
              :small="small"
              @Press="travel()">
  </router-btn>
</template>

<script>
import PageMap from "@/router/PageMap";
import ParamMap from "@/router/ParamMap";
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "NonAlfaBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },

  data() {
    return {
      pagemap: PageMap,
      parammap: ParamMap,
    };
  },

  methods: {
    travel() {
      this.backToOld();
    },
  },
};
</script>

